/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Manuallychangedname2Inputs */



/**

* @param {_Field_Manuallychangedname2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_manuallychangedname2 = /** @type {((inputs?: _Field_Manuallychangedname2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Manuallychangedname2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Name in Microsoft manuell geändert")
});
export { _field_manuallychangedname2 as "_field_manuallyChangedName" }